module.exports = __webpack_public_path__ + "img/rumi.a6b4398c.png";